import { VipInfo } from '@domain/types/player/player.data';
import { formatStringDate } from './format.utils';

export function getVipDate(vipInfo: VipInfo) {
  const { stars } = vipInfo;

  const date = vipInfo[`star${stars}Date`] as string | null;

  if (!date) return '';

  return formatStringDate(date);
}
